import { EmployeeProps } from "@/interfaces/employee_type";
import { SubmittalFormData } from "../SubmittalForm";

export function DefaultSubmittalProps(user: EmployeeProps): SubmittalFormData {
    return {
        submittal_id: "",
        received_date: new Date().toLocaleDateString('en-CA'),
        sub_description: "",
        project: { value: "", label: "" },
        assigned_to: { value: "", label: "" },
        assigned_by: { value: user.email, label: user.name },
        category: { value: "Mechanical", label: "Mechanical" },
        status: { value: "Active", label: "Active" },
    };
}
